module.exports = "<md-dialog class=md-dialog--m> <md-dialog-content class=md-dialog-content> <div class=md-dialog-title>Folders</div> <dt-folder-selector on-change=$ctrl.onFolderChange($event)></dt-folder-selector> </md-dialog-content> <md-dialog-actions class=\"spacae-p-h-l space-p-b-m\"> <md-button class=md-primary ng-click=$ctrl.close()> Close </md-button> <md-button class=md-primary ng-click=$ctrl.submit() ng-disabled=!$ctrl.folderId> View sensors in this folder </md-button> </md-dialog-actions> </md-dialog> ";


//////////////////
// WEBPACK FOOTER
// ./app/components/sensors-and-connectors/popups/folder-browser/template.html
// module id = 7Gr3
// module chunks = 1